// Import HTTP client
import {
  getBulkPayoutsService,
  initiateBulkPayoutService,
  getBulkPayoutConfigService,
  cancelBulkPayoutService,
  retryBulkPayoutService,
  updatePayoutService,
  toggleRecurringBulkPayoutService,
  getBulkPayoutLogsService,
  saveBeneficiaryService,
  initiateSinglePayoutService,
  getPayoutBeneficiariesService,
  getBulkPayoutService,
  getSupportedPayoutBanksService,
  approveDisapproveBulkPayoutService
} from '@/services/bulkPayoutService.js'
import { uploadFileService } from '@/services/utilsService.js'
import {
  SortTimeHandler,
  sortAmountHandler,
  SortNameHandler,
  sortAmountHandlerWithDoubleParams
} from '@/utils/helpers'

/** mutation types */
const set_ongoingBulkPayouts = 'set_ongoingBulkPayouts'
const set_historyBulkPayouts = 'set_historyBulkPayouts'
const set_activeComponent = 'set_activeComponent'
const set_bulkPayoutConfig = 'set_bulkPayoutConfig'
const set_initiatedBulkPayout = 'set_initiatedBulkPayout'
const set_initiatedSinglePayout = 'set_initiatedSinglePayout'
const set_currentBulkPayoutDetails = 'set_currentBulkPayoutDetails'
const set_bulkPayoutForm = 'set_bulkPayoutForm'
const set_bulkPayoutFormData = 'set_bulkPayoutFormData'
const sort_bulkPayoutTimeData = 'sort_bulkPayoutTimeData'
const sort_bulkPayoutAmountData = 'sort_bulkPayoutAmountData'
const sort_bulkPayoutNameData = 'sort_bulkPayoutNameData'
const set_bulkPayoutLogs = 'set_bulkPayoutLogs'
const set_beneficiaryDetails = 'set_beneficiaryDetails'
const set_beneficiaryId = 'set_beneficiaryId'
const set_payoutBeneficiaries = 'set_payoutBeneficiaries'
const set_payoutCurrency = 'set_payoutCurrency'
const set_paymentMethod = 'set_paymentMethod'
const set_supportedPayoutBanks = 'set_supportedPayoutBanks'
const set_payoutCount = 'set_payoutCount'
const set_selectedBeneficiaries = 'set_selectedBeneficiaries'
const remove_selectedBeneficiaries = 'remove_selectedBeneficiaries'
const sort_beneficiariesAmountData = 'sort_beneficiariesAmountData'
const sort_beneficiariesNameData = 'sort_beneficiariesNameData'
const set_uploadedFileUrls = 'set_uploadedFileUrls'

/** state */
const getDefaultState = () => {
  return {
    ongoingBulkPayouts: [],
    beneficiaryId: '',
    payoutCount: 0,
    historyBulkPayouts: [],
    activeComponent: 'bulk-payout-overview',
    bulkPayoutConfig: null,
    initiatedBulkPayout: null,
    currentBulkPayoutDetails: null,
    paymentMethod: 'banks',
    bulkPayoutForm: {},
    bulkPayoutFormData: null,
    bulkPayoutLogs: null,
    beneficiaryDetails: null,
    payoutBeneficiaries: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    },
    payoutCurrency: '',
    supportedPayoutBanks: [],
    selectedBeneficiaries: [],
    uploadedFileUrls: []
  }
}
const state = getDefaultState()
/** getters */
const getters = {}
/** mutations */
const mutations = {
  [set_beneficiaryId] (state, data) {
    state.beneficiaryId = data
  },
  [set_payoutCurrency] (state, data) {
    state.payoutCurrency = data
  },
  [set_beneficiaryDetails] (state, data) {
    state.beneficiaryDetails = data
  },
  [set_paymentMethod] (state, data) {
    state.paymentMethod = data
  },
  [set_payoutBeneficiaries] (state, data) {
    state.payoutBeneficiaries = data
  },
  [set_ongoingBulkPayouts] (state, data) {
    state.ongoingBulkPayouts = data
  },
  [set_historyBulkPayouts] (state, data) {
    state.historyBulkPayouts = data
  },
  [set_activeComponent] (state, data) {
    state.activeComponent = data
  },
  [set_bulkPayoutConfig] (state, data) {
    state.bulkPayoutConfig = data
  },
  [set_initiatedSinglePayout] (state, data) {
    state.initiatedSinglepayout = data
  },
  [set_initiatedBulkPayout] (state, data) {
    state.initiatedBulkPayout = data
  },
  [set_currentBulkPayoutDetails] (state, data) {
    state.currentBulkPayoutDetails = data
  },
  [set_bulkPayoutLogs] (state, data) {
    state.bulkPayoutLogs = data
  },
  [set_payoutCount] (state, data) {
    state.payoutCount = data
  },
  [set_bulkPayoutFormData] (state, data) {
    state.bulkPayoutFormData = data
  },
  [set_supportedPayoutBanks] (state, data) {
    state.supportedPayoutBanks = data
  },
  [set_selectedBeneficiaries] (state, data) {
    state.selectedBeneficiaries.push(data)
  },
  [remove_selectedBeneficiaries] (state, data) {
    state.selectedBeneficiaries = data
  },
  [set_bulkPayoutForm] (state, data) {
    state.bulkPayoutForm = data
  },
  [sort_bulkPayoutTimeData] (state, sortDirection) {
    state.ongoingBulkPayouts.items = SortTimeHandler(
      state.ongoingBulkPayouts.items,
      'createdAt',
      sortDirection
    )
    state.historyBulkPayouts.items = SortTimeHandler(
      state.historyBulkPayouts.items,
      'createdAt',
      sortDirection
    )
  },
  [sort_bulkPayoutAmountData] (state, sortDirection) {
    state.ongoingBulkPayouts.items = sortAmountHandler(
      state.ongoingBulkPayouts.items,
      'totalAmount',
      sortDirection
    )
    state.historyBulkPayouts.items = sortAmountHandler(
      state.historyBulkPayouts.items,
      'totalAmount',
      sortDirection
    )
  },
  [sort_bulkPayoutNameData] (state, sortDirection) {
    state.ongoingBulkPayouts.items = SortNameHandler(
      state.ongoingBulkPayouts.items,
      'remarks',
      sortDirection
    )
    state.historyBulkPayouts.items = SortNameHandler(
      state.historyBulkPayouts.items,
      'remarks',
      sortDirection
    )
  },
  [sort_beneficiariesAmountData] (state, sortDirection) {
    state.currentBulkPayoutDetails.attributes =
      sortAmountHandlerWithDoubleParams(
        state.currentBulkPayoutDetails.attributes,
        'amount',
        'amount',
        sortDirection
      )
  },
  [sort_beneficiariesNameData] (state, sortDirection) {
    state.currentBulkPayoutDetails.attributes = SortNameHandler(
      state.currentBulkPayoutDetails.attributes,
      'name',
      sortDirection
    )
  },
  [set_uploadedFileUrls] (state, data) {
    state.uploadedFileUrls = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}
/** actions */
const actions = {
  saveBeneficiary ({ commit }, payload) {
    return saveBeneficiaryService(payload).then((response) => {
      const details = {
        ...response.data.data.details,
        id: response.data.data.id
      }
      commit('set_beneficiaryDetails', details)
    })
  },
  savePayoutCurrency ({ commit }, currency) {
    commit('set_payoutCurrency', currency)
  },
  savePaymentMethod ({ commit }, method) {
    commit('set_paymentMethod', method)
  },
  getPayoutBeneficiaries ({ commit }, payload) {
    return getPayoutBeneficiariesService(payload).then((response) => {
      commit('set_payoutBeneficiaries', response.data.data)
    })
  },
  setBeneficiaryDetails ({ commit }, payload) {
    commit('set_beneficiaryDetails', payload)
  },
  setPayoutCount ({ commit }, payload) {
    commit('set_payoutCount', payload)
  },
  initiateSinglePayout ({ commit }, payload) {
    return initiateSinglePayoutService(payload).then((response) => {
      commit('set_initiatedSinglePayout', response.data.data)
    })
  },
  resetBulkPayoutState ({ commit }) {
    commit('resetState')
  },
  getBulkPayouts: ({ commit }, payload) => {
    return getBulkPayoutsService(payload).then((response) => {
      commit(`set_${payload.status}BulkPayouts`, response.data.data)
    })
  },
  setActiveComponent: ({ commit }, payload) => {
    commit('set_activeComponent', payload)
  },
  initiateBulkPayout: ({ commit }, payload) => {
    return initiateBulkPayoutService(payload).then((response) => {
      commit('set_initiatedBulkPayout', response.data.data)
    })
  },
  getBulkPayoutConfig: ({ commit }, payload) => {
    return getBulkPayoutConfigService(payload).then((response) => {
      commit('set_bulkPayoutConfig', response.data.data)
    })
  },
  getBulkPayout: ({ commit }, payload) => {
    return getBulkPayoutService(payload).then((response) => {
      commit('set_currentBulkPayoutDetails', response.data.data)
    })
  },
  getBulkPayoutLogs: ({ commit }, payload) => {
    return getBulkPayoutLogsService(payload).then((response) => {
      commit('set_bulkPayoutLogs', response.data.data)
    })
  },
  setCurrentBulkPayoutDetails: ({ commit }, payload) => {
    commit('set_currentBulkPayoutDetails', payload)
  },
  setBulkPayoutForm: ({ commit }, payload) => {
    commit('set_bulkPayoutForm', payload)
  },
  setBulkPayoutFormData: ({ commit }, payload) => {
    commit('set_bulkPayoutFormData', payload)
  },
  setSelectedBeneficiaries: ({ commit }, payload) => {
    commit('set_selectedBeneficiaries', payload)
  },
  removeSelectedBeneficiaries: ({ commit }, payload) => {
    commit('remove_selectedBeneficiaries', payload)
  },
  approveDisapproveBulkPayout: ({ commit }, payload) => {
    return approveDisapproveBulkPayoutService(payload)
  },
  cancelBulkPayout: ({ commit }, payload) => {
    return cancelBulkPayoutService(payload)
  },
  retryBulkPayout: ({ commit }, { logId, payload }) => {
    return retryBulkPayoutService(logId, payload)
  },
  updateBulkPayout: ({ commit }, payload) => {
    return updatePayoutService(payload)
  },
  toggleRecurringBulkPayout: ({ commit }, payload) => {
    return toggleRecurringBulkPayoutService(payload)
  },
  sortTimeHandler: ({ commit }, sortDirection) => {
    commit('sort_bulkPayoutTimeData', sortDirection)
  },
  sortAmountHandler: ({ commit }, sortDirection) => {
    commit('sort_bulkPayoutAmountData', sortDirection)
  },
  sortNameHandler: ({ commit }, sortDirection) => {
    commit('sort_bulkPayoutNameData', sortDirection)
  },
  getSupportedPayoutBanks: ({ commit }, payload) => {
    return getSupportedPayoutBanksService(payload).then((response) => {
      commit('set_supportedPayoutBanks', response.data.data)
    })
  },
  sortBeneficiariesNameData: ({ commit }, sortDirection) => {
    commit('sort_beneficiariesNameData', sortDirection)
  },
  sortBeneficiariesAmountData: ({ commit }, sortDirection) => {
    commit('sort_beneficiariesAmountData', sortDirection)
  },
  uploadFile: ({ commit }, payload) => {
    return uploadFileService(payload).then((response) =>
      commit('set_uploadedFileUrls', response.data.data)
    )
  },
  resetUploadedFileUrls: ({ commit }) => {
    commit('set_uploadedFileUrls', [])
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
